import React from 'react'
import { Navigate } from 'react-router-dom'

import RegisterScreen from '~/screens/authentication/register/register'
import ForgotPasswordScreen from '~/screens/authentication/forgot_password'
import NotFound from '~/screens/not_found/not_found'
import IdinRegisterScreen from '~/screens/authentication/register/idin_register'
import CaseScreen from '~/screens/case/case_screen'
import PoliciesScreen from '~/screens/policies/policies_screen/policies_screen'
import MemberBenefitScreen from '~/screens/member_benefit/member_benefit_screen'
import AdvisorScreen from '~/screens/advisor/advisor_screen'
import MoreScreen from '~/screens/more/more_screen'
import ClaimDamageScreen from '~/screens/claim_damage/ClaimDamageScreen'
import NotificationsScreen from '~/screens/notifications/notifications_screen'
import ProfileScreen from '~/screens/profile/profile_screen/profile_screen'
import NotificationDetailScreen from '~/screens/notifications/notification_detail_screen'
import PaymentsScreen from '~/screens/case/payments/payments_screen'
import GreenCardsScreen from '~/screens/case/green_cards/green_cards_screen'
import ClaimOverviewScreen from '~/screens/case/claims/claim_overview_screen/claim_overview_screen'
import MemberBenefitDetailScreen from '~/screens/member_benefit/member_benefit_detail_screen/member_benefit_detail_screen'
import AboutNH1816Screen from '~/screens/more/detail_screens/about_nh1816_screen'
import AboutAppScreen from '~/screens/more/detail_screens/about_app_screen'
import QuestionsScreen from '~/screens/more/detail_screens/questions_screen/questions_screen'
import PreventionTipCategoriesScreen from '~/screens/more/detail_screens/prevention_tips/prevention_tip_categories_screen'
import PreventionTipScreen from '~/screens/more/detail_screens/prevention_tips/prevention_tip_screen'
import TermsOfUseScreen from '~/screens/more/detail_screens/terms_of_use_screen'
import ForgotPasswordVerifyScreen from '~/screens/authentication/forgot_password_verify'
import ClaimDetailScreen from '~/screens/case/claims/claim_detail_screen'
import SelectCombiPolicyScreen from '~/screens/profile/select_combi_policy_screen/select_combi_policy_screen'
import HomeScreen from '~/screens/home/home_screen'
import PolicyDetailScreen from '~/screens/policies/policy_detail_screen/policy_detail_screen'
import PolicyAdvice from '~/screens/policies/policy_advice'
import PolicyAdviceRequested from '~/screens/policies/policy_advice_requested'
import ManageLoginScreen from '~/screens/profile/manage_login/manage_login_screen'
import PreferencesScreen from '~/screens/profile/preferences_screen'
import PreferenceDetailScreen from '~/screens/profile/preferences_screen/preference_detail_screen'
import { preferenceRoutes } from '~/screens/profile/preferences_screen/preferences_config'
import ManageRelationScreen from '~/screens/profile/manage_relation/manage_relation_screen'
import ManageMembersScreen from '~/screens/profile/manage_members/manage_members_screen'
import InviteMemberScreen from '~/screens/profile/manage_members/invite_member_screen'
import DamageRepairVehicleScreen from '~/screens/damagerepair/DamageRepairVehicleScreen'
import AddCombiPolicyScreen from '~/screens/profile/add_combi_policy_screen/add_combi_policy_screen'
import WhatToDoScreen from '~/screens/what_to_do/what_to_do_screen'
import LoginScreen from '~/screens/authentication/login'
import ClaimDamageFormScreen from '~/screens/claim_damage/claim_damage_form_screen'
import ValueMetersScreen from '~/screens/case/valuemeters/ValueMetersScreen'
import RebuildValueMeterScreen from '~/screens/case/valuemeters/RebuildValueMeterScreen'
import HouseHoldEffectsScreen from '~/screens/case/valuemeters/HouseHoldEffectsScreen'
import CombiPolicyDetailScreen from '~/screens/profile/combi_policy_details_screen/CombiPolicyDetailsScreen'
import GenerateGreenCard from '~/screens/policies/GenerateGreenCard'
import RegisterWithToken from '~/screens/authentication/register/RegisterWithToken'
import Setup from '~/screens/authentication/setup/Setup'
import VerifyInvite from '~/screens/authentication/verify_invite'
import VerifyAddResourceAuthorization from '~/screens/authentication/verify_add_resource_authorization'
import UnblockUser from '~/screens/authentication/unblock_user'

export type RouteGuard = 'public' | 'auth' | 'protected'

export type AppRouteConfig = {
  path: string
  name: string
  title?: string
  guard: RouteGuard
  element: React.ReactNode
}

export const appRoutes: AppRouteConfig[] = [
  {
    path: '/home',
    name: 'Login',
    title: 'Inloggen',
    guard: 'auth',
    element: <LoginScreen />
  },
  {
    path: '/register',
    name: 'Registreren',
    title: 'Registreren',
    guard: 'auth',
    element: <RegisterScreen />
  },
  {
    path: '/idin',
    name: 'Identificeren',
    title: 'Idin registratie',
    guard: 'auth',
    element: <IdinRegisterScreen />
  },
  {
    path: '/idin-register',
    name: 'Identificeren',
    title: 'Idin registratie',
    guard: 'auth',
    element: <IdinRegisterScreen />
  },
  {
    path: '/forget-password',
    name: 'Wachtwoord vergeten',
    title: 'Wachtwoord vergeten',
    guard: 'auth',
    element: <ForgotPasswordScreen />
  },
  {
    path: '/forgot-password',
    name: 'Wachtwoord veranderen',
    title: 'Wachtwoord veranderen',
    guard: 'auth',
    element: <ForgotPasswordVerifyScreen />
  },
  {
    path: '/registration',
    name: 'Registreren',
    title: 'Registreren',
    guard: 'auth',
    element: <RegisterWithToken />
  },
  {
    path: '/user/verify-invite',
    name: 'Subgebruiker registreren',
    title: 'Registreren',
    guard: 'public',
    element: <VerifyInvite />
  },
  {
    path: '/verify-add-resource-authorization',
    name: 'Combipolis verifiëren',
    title: 'Combipolis verifiëren',
    guard: 'public',
    element: <VerifyAddResourceAuthorization />
  },
  {
    path: '/user-blocked',
    name: 'Wachtwoord opnieuw instellen',
    title: 'Wachtwoord opnieuw instellen',
    guard: 'auth',
    element: <UnblockUser />
  },
  {
    path: '/instellen',
    name: 'Instellen',
    title: 'Instellen',
    guard: 'protected',
    element: <Setup />
  },
  {
    path: '/overzicht',
    name: 'Home',
    title: 'Overzicht',
    guard: 'protected',
    element: <HomeScreen />
  },
  {
    path: '/dossier',
    name: 'Dossier',
    title: 'Dossier',
    guard: 'protected',
    element: <CaseScreen />
  },
  {
    path: '/dossier/betalingsoverzicht',
    name: 'Betalingsoverzicht',
    title: 'Betalingsoverzicht',
    guard: 'protected',
    element: <PaymentsScreen />
  },
  {
    path: '/dossier/verzekeringsbewijzen',
    name: 'Verzekeringsbewijzen',
    title: 'Verzekeringsbewijzen',
    guard: 'protected',
    element: <GreenCardsScreen />
  },
  {
    path: '/dossier/waardemeters',
    name: 'Waardemeters',
    title: 'Waardemeters',
    guard: 'protected',
    element: <ValueMetersScreen />
  },
  {
    path: '/dossier/waardemeters/herbouwwaardemeter/:id',
    name: 'Herbouwwaardemeter',
    title: 'Herbouwwaardemeter',
    guard: 'protected',
    element: <RebuildValueMeterScreen />
  },
  {
    path: '/dossier/waardemeters/inboedelwaardemeter/:id',
    name: 'Inboedelwaardemeter',
    title: 'Inboedelwaardemeter',
    guard: 'protected',
    element: <HouseHoldEffectsScreen />
  },
  {
    path: '/dossier/mijn-schades',
    name: 'Mijn schades',
    title: 'Mijn schades',
    guard: 'protected',
    element: <ClaimOverviewScreen />
  },
  {
    path: '/dossier/mijn-schades/:id',
    name: 'Schadedossier',
    title: 'Schade',
    guard: 'protected',
    element: <ClaimDetailScreen />
  },
  {
    path: '/verzekeringen',
    name: 'Verzekeringen',
    title: 'Verzekeringen',
    guard: 'protected',
    element: <PoliciesScreen />
  },
  {
    path: '/verzekeringsbewijzen/genereren/:policyNumber',
    name: 'Verzekeringsbewijs genereren',
    title: 'Verzekeringsbewijs genereren',
    guard: 'protected',
    element: <GenerateGreenCard />
  },
  {
    path: '/verzekeringen/combipolis',
    name: 'Combipolis',
    title: 'Combipolis',
    guard: 'protected',
    element: <CombiPolicyDetailScreen />
  },
  {
    path: '/verzekeringen/polis/:id',
    name: 'Verzekering',
    guard: 'protected',
    element: <PolicyDetailScreen />
  },
  {
    path: '/verzekeringen/verzekeringsadvies',
    name: 'Verzekeringsadvies toevoegen',
    title: 'Verzekeringsadvies toevoegen',
    guard: 'protected',
    element: <PolicyAdvice />
  },
  {
    path: '/verzekeringen/advies-aangevraagd',
    name: 'Verzekeringsadvies aangevraagd',
    title: 'Verzekeringsadvies aangevraagd',
    guard: 'protected',
    element: <PolicyAdviceRequested />
  },
  {
    path: '/ledenvoordelen',
    name: 'Ledenvoordelen',
    title: 'Ledenvoordelen',
    guard: 'protected',
    element: <MemberBenefitScreen />
  },
  {
    path: '/ledenvoordelen/:id',
    name: 'Ledenvoordeel',
    title: 'Ledenvoordeel',
    guard: 'protected',
    element: <MemberBenefitDetailScreen />
  },
  {
    path: '/adviseur',
    name: 'Adviseur',
    title: 'Adviseur',
    guard: 'protected',
    element: <AdvisorScreen />
  },
  {
    path: '/wat-te-doen-bij/:id',
    name: 'Wat te doen',
    title: 'Wat te doen',
    guard: 'protected',
    element: <WhatToDoScreen />
  },
  {
    path: '/meer',
    name: 'Meer',
    title: 'Meer',
    guard: 'protected',
    element: <MoreScreen />
  },
  {
    path: '/meer/nh1816-verzekeringen',
    name: 'Over Nh1816',
    title: 'Over Nh1816',
    guard: 'protected',
    element: <AboutNH1816Screen />
  },
  {
    path: '/meer/over-de-app',
    name: 'Over applicatie',
    title: 'Over de app',
    guard: 'protected',
    element: <AboutAppScreen />
  },
  {
    path: '/meer/preventietips',
    name: 'Preventietips',
    title: 'Preventietips',
    guard: 'protected',
    element: <PreventionTipCategoriesScreen />
  },
  {
    path: '/meer/preventietips/:id',
    name: 'Preventietip',
    title: 'Preventietip',
    guard: 'protected',
    element: <PreventionTipScreen />
  },
  {
    path: '/meer/vragen',
    name: 'Veelgestelde vragen',
    title: 'Veelgestelde vragen',
    guard: 'protected',
    element: <QuestionsScreen />
  },
  {
    path: '/meer/ledenvoordelen',
    name: 'Ledenvoordelen',
    title: 'Ledenvoordelen',
    guard: 'protected',
    element: <MemberBenefitScreen />
  },
  {
    path: '/meer/gebruiksvoorwaarden',
    name: 'Gebruiksvoorwaarden',
    title: 'Gebruiksvoorwaarden',
    guard: 'protected',
    element: <TermsOfUseScreen />
  },
  {
    path: '/verzekeringsbewijzen',
    name: 'Verzekeringsbewijzen',
    title: 'Verzekeringsbewijzen',
    guard: 'protected',
    element: <GreenCardsScreen />
  },
  {
    path: '/schade-melden',
    name: 'Schade melden',
    title: 'Schade melden',
    guard: 'protected',
    element: <ClaimDamageScreen />
  },
  {
    path: '/schade-melden/schadeformulier',
    name: 'Schadeformulier',
    title: 'Schadeformulier',
    guard: 'protected',
    element: <ClaimDamageFormScreen />
  },
  {
    path: '/notificaties',
    name: 'Berichten',
    title: 'Notificaties',
    guard: 'protected',
    element: <NotificationsScreen />
  },
  {
    path: '/notificaties/:id',
    name: 'Bericht',
    guard: 'protected',
    element: <NotificationDetailScreen />
  },
  {
    path: '/mijn-profiel',
    name: 'Profiel',
    title: 'Profiel',
    guard: 'protected',
    element: <ProfileScreen />
  },
  {
    path: '/mijn-profiel/combipolis-selecteren',
    name: 'Combipolis selecteren',
    title: 'Combipolis selecteren',
    guard: 'protected',
    element: <SelectCombiPolicyScreen />
  },
  {
    path: '/mijn-profiel/combipolis-toevoegen',
    name: 'Combipolis toevoegen',
    title: 'Combipolis toevoegen',
    guard: 'protected',
    element: <AddCombiPolicyScreen />
  },
  {
    path: '/mijn-profiel/accountgegevens-wijzigen',
    name: 'Inloggegevens wijzigen',
    title: 'Accountgegevens wijzigen',
    guard: 'protected',
    element: <ManageLoginScreen />
  },
  {
    path: '/mijn-profiel/voorkeuren',
    name: 'Voorkeuren',
    title: 'Voorkeuren',
    guard: 'protected',
    element: <PreferencesScreen />
  },
  {
    path: preferenceRoutes['cooperation-membership'].path,
    name: preferenceRoutes['cooperation-membership'].title,
    title: preferenceRoutes['cooperation-membership'].title,
    guard: 'protected',
    element: <PreferenceDetailScreen preference='cooperation-membership' />
  },
  {
    path: preferenceRoutes['zest-magazine'].path,
    name: preferenceRoutes['zest-magazine'].title,
    title: preferenceRoutes['zest-magazine'].title,
    guard: 'protected',
    element: <PreferenceDetailScreen preference='zest-magazine' />
  },
  {
    path: preferenceRoutes['customer-panel'].path,
    name: preferenceRoutes['customer-panel'].title,
    title: preferenceRoutes['customer-panel'].title,
    guard: 'protected',
    element: <PreferenceDetailScreen preference='customer-panel' />
  },
  {
    path: preferenceRoutes.display.path,
    name: preferenceRoutes.display.title,
    title: preferenceRoutes.display.title,
    guard: 'protected',
    element: <PreferenceDetailScreen preference='display' />
  },
  {
    path: '/mijn-profiel/gebruikers-beheren',
    name: 'Gebruikers beheren',
    title: 'Gebruikers beheren',
    guard: 'protected',
    element: <ManageMembersScreen />
  },
  {
    path: '/mijn-profiel/gebruikers-beheren/uitnodigen',
    name: 'Gebruiker toevoegen',
    title: 'Gebruiker toevoegen',
    guard: 'protected',
    element: <InviteMemberScreen />
  },
  {
    path: '/mijn-profiel/gegevens-wijzigen',
    name: 'Relatiegegevens wijzigen',
    title: 'Relatiegegevens wijzigen',
    guard: 'protected',
    element: <ManageRelationScreen />
  },
  {
    path: '/schadehersteller/voertuigschade',
    name: 'Voertuig schadeherstellers',
    title: 'Voertuig schadeherstellers',
    guard: 'protected',
    element: <DamageRepairVehicleScreen />
  },
  {
    path: '/',
    name: 'Home',
    title: 'Overzicht',
    guard: 'protected',
    element: <Navigate to='/overzicht' />
  },
  {
    path: '*',
    name: 'NotFound',
    title: 'Pagina niet gevonden',
    guard: 'public',
    element: <NotFound />
  }
]
